import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

const Col = ({ children, className, gutter }) => {
  const classNameRoot = classNames('Col', className);
  const padding = `${gutter / 2}rem`;
  const styleRoot = { paddingLeft: padding, paddingRight: padding };
  return (
    <div className={classNameRoot} style={styleRoot}>
      {children}
    </div>
  );
};

Col.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  gutter: PropTypes.number,
};

Col.defaultProps = {
  className: null,
  gutter: 1,
};

export default Col;



// WEBPACK FOOTER //
// ./src/components/Grid/Col/index.js